import { render, staticRenderFns } from "./td-primary.vue?vue&type=template&id=4e16c698&scoped=true"
import script from "./td-primary.vue?vue&type=script&lang=js"
export * from "./td-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e16c698",
  null
  
)

export default component.exports